
let Courses = [
  {
    title: "Introdução ao Power BI - Parte 1",
    instructor: "Felipe Correa Veloso Dos Santos",
    institution: "PUC-Goiás",
    desc: `Parte 1 do mini-curso: "Introdução ao Power BI".`,
    date: "17/04",
    time: "14:00-17:00",
    place: "Lab. Informática: sala 101, bloco C, área II",
  }, 

  {
    title: "Introdução ao Power BI - Parte 2",
    instructor: "Felipe Correa Veloso Dos Santos",
    institution: "PUC-Goiás",
    desc: `Parte 2 do mini-curso: "Introdução ao Power BI"`,
    date: "18/04",
    time: "14:00-17:00",
    place: "Lab. Informática: sala 101, bloco C, área II",
  }, 

  {
    title: "Módulos úteis em Python",
    instructor: "Rafael Leal Martins",
    institution: "PUC Goiás e Fundação Jaime Câmara",
    desc: `A oficina apresentará módulos da linguagem Python, para solucionar diversos problemas computacionais.`,
    date: "18/04",
    time: "09:00-10:30",
    place: "Lab. Informática: sala 101, bloco C, área II",
  }, 

  {
    title: "Produção de óleos essenciais - Parte 1",
    instructor: "Ronice Alves Veloso",
    institution: "Faculdades Integradas da América do Sul (INTEGRA)",
    desc: `Parte 1 do mini-curso: "Produção de óleos essenciais"`,
    date: "18/04",
    time: "14:00-17:00",
    place: "Lab. Química: sala 007, bloco H, área III",
  }, 

  {
    title: "Produção de óleos essenciais - Parte 2",
    instructor: "Ronice Alves Veloso",
    institution: "Faculdades Integradas da América do Sul (INTEGRA)",
    desc: `Parte 2 do mini-curso: "Produção de óleos essenciais"`,
    date: "19/04",
    time: "14:00-17:00",
    place: "Lab. Química: sala 007, bloco H, área III",
  }, 

  {
    title: "Módulos úteis em Python",
    instructor: "Rafael Leal Martins",
    institution: "PUC Goiás e Fundação Jaime Câmara",
    desc: `A oficina apresentará módulos da linguagem Python, para solucionar diversos problemas computacionais.`,
    date: "19/04",
    time: "09:00-10:30",
    place: "Lab. Informática: sala 101, bloco C, área II",
  }, 

  {
    title: "Módulos úteis em Python",
    instructor: "Rafael Leal Martins",
    institution: "PUC Goiás e Fundação Jaime Câmara",
    desc: `A oficina apresentará módulos da linguagem Python, para solucionar diversos problemas computacionais.`,
    date: "19/04",
    time: "20:30-22:00",
    place: "Lab. Informática: sala 101, bloco C, área II",
  }, 

  {
    title: "Avaliação de máquinas, equipamentos e bens móveis",
    instructor: "Ricardo Vitoy",
    institution: "PUC Goiás",
    desc: `O minicurso abordará temas como custos direto e indireto de instalação, depreciação inicial e desmontagem, valor de equipamentos (sucata, econômico, uso e de risco). Classificação de máquinas, equipamentos, instalações e bens industriais em geral. Metodologia de avaliação de máquinas.
    Vagas limitadas: 20`,
    date: "17/04",
    time: '08:30-12:00',
    place: 'Laboratório: sala 002, bloco J, área III ',
  },

  /* 
  {
    title: "Aplicações em Engenharia utilizando o software Smath Solver",
    instructor: "Prof. Me. Alberto Vilela Chaer",
    institution: "PUC Goiás",
    desc: `O minicurso “Aplicações em Engenharia utilizando o software Smath Solver” tem como objetivo apresentar as possibilidades que este programa – gratuito a partir de download em página oficial na web (https://en.smath.com/view/SMathStudio/summary) – oferece para elaboração de cálculos e geração da respectiva memória de cálculo de um problema qualquer que tenha sua resolução a partir de utilização de expressões matemáticas.  Trata-se de um programa bastante robusto e amplamente conhecido pelo nome de “SMath Studio” utilizado em universidades do Brasil e exterior, sendo uma ferramenta de sedimentação do processo ensino-aprendizagem, através da simulação dos eventos envolvidos em um cálculo. O benefício da utilização deste programa é utilizar da rapidez dos cálculos feitos por meio da máquina, cujas operações e lógica são conduzidas pelo desenvolvimento do usuário, para que se possa tomar conclusões e decisões a partir dos resultados. Uma ferramenta que se constitui em um “caderno de exercícios” de Professores, Estudantes e Profissionais de Engenharia. Recomenda-se que os participantes do referido minicurso acessem a sessão por meio de computador pessoal (sistema operacional Windows e Linux; também por versão Open in browser) para melhor rendimento durante a preleção e atividades propostas, apesar de que o software também tem sua versão gratuita para ser instalada em aparelho celular no sistema Android. `,
    date: "09/05",
    time: "14:00-18:00",
    place: "Microsoft Teams",
    link: "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fmeetup-join%2F19%3Ameeting_MWUzMzEwYjQtOTliZC00Zjc0LTk5NGItMmM1NWZmNzM2YTdk%40thread.v2%2F0%3Fcontext%3D%257b%2522Tid%2522%253a%252273319f42-8908-4b89-9f8d-558cf4d5d776%2522%252c%2522Oid%2522%253a%25224d5d6768-2ee9-4adc-ac86-4da09deed785%2522%257d%26anon%3Dtrue&type=meetup-join&deeplinkId=d5ded907-37d1-4a3c-b2f5-6ac85819b99e&directDl=true&msLaunch=true&enableMobilePage=true&suppressPrompt=true"
  }, 
  {
    title: "Ferramentas computacionais para o desenho de projeto de arquitetura",
    instructor: "Alessandro Miguel de Oliveira",
    institution: "PUC Goiás",
    desc: `Uso do AutoCAD para o desenho de projeto, geometria descritiva, elementos constitutivos das edificações e representação arquitetônica.`,
    date: "08, 09 e 10/05",
    time: "14:00-17:00",
    place: 'Presencial: Laboratóro 102, Bloco B, Área III'
  },

  {
    title: "Introdução a Python",
    instructor: 'Eugenio José Moura Neto',
    institution: 'Aluno da PUC Goiás.',
    desc: `Iniciação à linguagem de programação Python. Vagas limitadas a 20 alunos.`,
    date: '09/05',
    time: '14:00-16:00',
    place: 'Presencial: Laboratório 101, bloco C, área II'
  
  },

  {
    title: "Introdução ao Git/GitHub",
    instructor: 'Milton de Assis Ribeiro Neto',
    institution: 'PUC Goiás',
    desc: `Como usar o Git/Github? Minicurso presencial, porém com gravação pelo Teams.`,
    date: '10/05',
    time: '17:00-19:00',
    place: 'Presencial: Laboratório 101, bloco C, área II e Transmissão pelo Teams',
    link: "https://teams.microsoft.com/l/meetup-join/19%3ameeting_Zjk4YTIwZGYtYjRhMC00NGQ5LTk4ZGQtODhiYmVkNGRlZGJk%40thread.v2/0?context=%7b%22Tid%22%3a%2273319f42-8908-4b89-9f8d-558cf4d5d776%22%2c%22Oid%22%3a%224d5d6768-2ee9-4adc-ac86-4da09deed785%22%7d"
  
  },
  
  {
    title: "Introdução a Estrutura de Dados em Python",
    instructor: 'Daniel Ribeiro de Brito',
    institution: 'Aluno da PUC Goiás',
    desc: `Este minicurso é uma continuação do curso de Introdução a Python. Serão vistas estruturas de dados simples utilizando a linguagem Python.`,
    date: '10/05',
    time: '14:00-16:00',
    place: 'Presencial: Laboratório 105, bloco C, área II'

  },
  */
 /*  link: ""
    */
]

/*
const Courses_Civil = [
]

const Courses_Computacao = [
  


]

const Courses_Producao = [
  
]

const Courses_Caer = [
  
]

*/
Courses = Courses.sort((a, b) => {
  if(a.date < b.date) return -1;
  if(a.date > b.date) return 1;
  if(a.time < b.time) return -1;
  if(a.time > b.time) return 1;
  if(a.title < b.title) return -1;
  if(a.title > b.title) return 1;
  return 0;
});

export const miniCourses_Section = [
  {
    curso: "Agronomia",
    minicurso: Courses,
  },
  /*
  {
    curso: 'Ciências Aeronáuticas',
    minicurso: Courses_Caer
  },
  {
    curso: "Civil",
    minicurso: Courses_Civil
  },
  {
    curso: "Computacao",
    minicurso: Courses_Computacao
  },
  {
    curso: "Producao",
    minicurso: Courses_Producao
  },
  */
]